// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IOSLayoutSettingsForm-space1-dppT8 {
	margin-bottom: 6px !important;
}

.IOSLayoutSettingsForm-space2-ESoXo {
	margin-bottom: 12px !important;
}

.IOSLayoutSettingsForm-space3-IajLq {
	margin-bottom: 18px !important;
}

.IOSLayoutSettingsForm-space4-cvvrV {
	margin-bottom: 24px !important;
}

.IOSLayoutSettingsForm-space5-wMt0u {
	margin-bottom: 30px !important;
}

.IOSLayoutSettingsForm-space6-Z7FFv {
	margin-bottom: 36px !important;
}

.IOSLayoutSettingsForm-space7-d3GRk {
	margin-bottom: 42px !important;
}

.IOSLayoutSettingsForm-space8-XD7KG {
	margin-bottom: 48px !important;
}

.IOSLayoutSettingsForm-spaceTop1-EEd41 {
	margin-top: 6px !important;
}

.IOSLayoutSettingsForm-spaceTop2-GpyA0 {
	margin-top: 12px !important;
}

.IOSLayoutSettingsForm-spaceTop3-JMGKI {
	margin-top: 18px !important;
}

.IOSLayoutSettingsForm-spaceTop4-RQG2A {
	margin-top: 24px !important;
}

.IOSLayoutSettingsForm-spaceTop5-Ur2EU {
	margin-top: 30px !important;
}

.IOSLayoutSettingsForm-spaceTop6-PjHvH {
	margin-top: 36px !important;
}

.IOSLayoutSettingsForm-spaceTop7-d7LnP {
	margin-top: 42px !important;
}

.IOSLayoutSettingsForm-spaceTop8-ppnEW {
	margin-top: 48px !important;
}

.IOSLayoutSettingsForm-noMargin-e3Xnh {
	margin: 0px !important;
}

.IOSLayoutSettingsForm-padding1-Rb8pa {
	padding-bottom: 6px !important;
}

.IOSLayoutSettingsForm-padding2-Wku5W {
	padding-bottom: 12px !important;
}

.IOSLayoutSettingsForm-padding3-n8Tp9 {
	padding-bottom: 18px !important;
}

.IOSLayoutSettingsForm-padding4-My5Eq {
	padding-bottom: 24px !important;
}

.IOSLayoutSettingsForm-padding5-YMk5e {
	padding-bottom: 30px !important;
}

.IOSLayoutSettingsForm-padding6-P5fs5 {
	padding-bottom: 36px !important;
}

.IOSLayoutSettingsForm-padding7-vm9b4 {
	padding-bottom: 42px !important;
}

.IOSLayoutSettingsForm-paddingTop1-Ju9Kz {
	padding-top: 6px !important;
}

.IOSLayoutSettingsForm-paddingTop2-OqmDD {
	padding-top: 12px !important;
}

.IOSLayoutSettingsForm-paddingTop3-F0tJs {
	padding-top: 18px !important;
}

.IOSLayoutSettingsForm-paddingTop4-lZGdi {
	padding-top: 24px !important;
}

.IOSLayoutSettingsForm-paddingTop5-ztyFU {
	padding-top: 30px !important;
}

.IOSLayoutSettingsForm-paddingTop6-YmXsB {
	padding-top: 36px !important;
}

.IOSLayoutSettingsForm-paddingTop7-L0ugk {
	padding-top: 42px !important;
}

.IOSLayoutSettingsForm-noPadding-lImIQ {
	padding: 0px !important;
}

.IOSLayoutSettingsForm-spaceMarginBottom0-RkZd_ {
	margin-bottom: 0;
}

.IOSLayoutSettingsForm-textBold-BDsbp {
	font-weight: 500 !important;
}

.IOSLayoutSettingsForm-textBolder-u5Od8 {
	font-weight: 700 !important;
}

.IOSLayoutSettingsForm-textNormal-FttFd {
	font-weight: normal !important;
}

/*New Design Text Colors */

.IOSLayoutSettingsForm-textDarkBlue-BV8WI {
	color: rgb(20, 39, 94) !important;
}

.IOSLayoutSettingsForm-textLightBlue-cm6Yr {
	color: rgb(57, 87, 106) !important;
}

.IOSLayoutSettingsForm-textLightSandleGreen-ivKU8 {
	color: rgb(76, 86, 41) !important;
}

.IOSLayoutSettingsForm-textLightBrown-B3P6p {
	color: rgb(115, 79, 33) !important;
}

.IOSLayoutSettingsForm-textMediumMaroon-ZtmR3 {
	color: rgb(87, 37, 51) !important;
}

.IOSLayoutSettingsForm-textBrown-VXs6a {
	color: rgb(160, 47, 24) !important;
}

.IOSLayoutSettingsForm-textMaroon-jh1r5 {
	color: rgb(155, 49, 67) !important;
}

.IOSLayoutSettingsForm-textDarkBrown-eq8qb {
	color: rgb(83, 18, 16) !important;
}

.IOSLayoutSettingsForm-textMediumBrown-yfeJP {
	color: rgb(142, 28, 10) !important;
}

.IOSLayoutSettingsForm-textSkyBlue-_nIPr {
	color: rgb(37, 117, 141) !important;
}

.IOSLayoutSettingsForm-textGray-VGOHT {
	color: rgb(77, 65, 51) !important;
}

.IOSLayoutSettingsForm-errorMessage-yNyKr {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.IOSLayoutSettingsForm-userText-g4wDg {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.IOSLayoutSettingsForm-panelHeader-sjxgb {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.IOSLayoutSettingsForm-exportSection-KQWTL {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.IOSLayoutSettingsForm-exportSectionGridSub-bBtif {
	grid-template-columns: 50% 49% !important;
}

.IOSLayoutSettingsForm-exportText-YFMty {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.IOSLayoutSettingsForm-exportLinkImg-BM_mV {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.IOSLayoutSettingsForm-exportImg-E0YKr {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.IOSLayoutSettingsForm-linkBtn-HzET8 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.IOSLayoutSettingsForm-table-Nxyp3 {
	display: table;
}

.IOSLayoutSettingsForm-tableRow-JSkuX {
	display: table-row;
}

.IOSLayoutSettingsForm-tableCell-ivqtn {
	display: table-cell;
	float: none;
}

.IOSLayoutSettingsForm-formGroup-_69hd {
	margin-bottom: 6px;
}

.IOSLayoutSettingsForm-marginTop0-GOnqJ {
	margin-top: 0;
}

.IOSLayoutSettingsForm-marginBottom20-b6fYt {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.IOSLayoutSettingsForm-bannerImageBg-YW5Ra {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.IOSLayoutSettingsForm-bannerDelete-JrtLp {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.IOSLayoutSettingsForm-exportLink-gITfw {
	padding-top: 10px;
	padding-right: 10px;
}

.IOSLayoutSettingsForm-seachContent-ziwct {
	padding-left: 0px;
	margin-bottom: 5px;
}

.IOSLayoutSettingsForm-marginBottom9-SCjAt {
	margin-bottom: 9px;
}

.IOSLayoutSettingsForm-spaceTop52-MJNk7 {
	margin-top: 52px;
}

.IOSLayoutSettingsForm-profileViewInner-vu6jo {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.IOSLayoutSettingsForm-profileViewMain-tZmm8 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.IOSLayoutSettingsForm-profileViewlabel-bYDVm {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.IOSLayoutSettingsForm-profileViewMainContent-buCWK {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.IOSLayoutSettingsForm-reviewsFormStar-Kz0lE {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.IOSLayoutSettingsForm-reviewsFormStar-Kz0lE svg {
	cursor: pointer;
}

.IOSLayoutSettingsForm-addLanguageText-cy50T {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.IOSLayoutSettingsForm-exportSection-KQWTL {
		grid-template-columns: 100%;
	}

	.IOSLayoutSettingsForm-spaceTop52-MJNk7 {
		margin-top: 18px;
	}

	.IOSLayoutSettingsForm-exportText-YFMty {
		float: none;
		margin-top: 12px;
	}

	.IOSLayoutSettingsForm-exportSectionGridSub-bBtif {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.IOSLayoutSettingsForm-profileViewlabel-bYDVm {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.IOSLayoutSettingsForm-profileViewMainContent-buCWK {
		width: 100%;
		text-align: center;
	}

	.IOSLayoutSettingsForm-panelHeader-sjxgb {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.IOSLayoutSettingsForm-themeRowContainer-qnorq {
    display: grid;
    grid-template-columns: 206px repeat(2, 1fr);
    gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.IOSLayoutSettingsForm-adminHorizontalDevided-O44jN {
    margin: 24px 0px;
    border-top: 1px solid var(--primary-border);
}

.IOSLayoutSettingsForm-previewContainer-TZuGQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
}

.IOSLayoutSettingsForm-iosPreviewLink-exk5n {
    font-size: 18px;
    color: var(--common-link-color);
    font-weight: 500;
    line-height: 23px;
    border-bottom: 1px solid var(--common-link-color);
    cursor: pointer;
}

@media (max-width: 767px) {
    .IOSLayoutSettingsForm-themeRowContainer-qnorq {
        grid-template-columns: 100%;
        gap: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/IOSLayoutSettingsForm/IOSLayoutSettingsForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI;QACI,2BAA2B;QAC3B,SAAS;IACb;AACJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.themeRowContainer {\n    display: grid;\n    grid-template-columns: 206px repeat(2, 1fr);\n    gap: 24px;\n    align-items: flex-start;\n}\n\n.adminHorizontalDevided {\n    margin: 24px 0px;\n    border-top: 1px solid var(--primary-border);\n}\n\n.previewContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.iosPreviewLink {\n    font-size: 18px;\n    color: var(--common-link-color);\n    font-weight: 500;\n    line-height: 23px;\n    border-bottom: 1px solid var(--common-link-color);\n    cursor: pointer;\n}\n\n@media (max-width: 767px) {\n    .themeRowContainer {\n        grid-template-columns: 100%;\n        gap: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `IOSLayoutSettingsForm-space1-dppT8`,
	"space2": `IOSLayoutSettingsForm-space2-ESoXo`,
	"space3": `IOSLayoutSettingsForm-space3-IajLq`,
	"space4": `IOSLayoutSettingsForm-space4-cvvrV`,
	"space5": `IOSLayoutSettingsForm-space5-wMt0u`,
	"space6": `IOSLayoutSettingsForm-space6-Z7FFv`,
	"space7": `IOSLayoutSettingsForm-space7-d3GRk`,
	"space8": `IOSLayoutSettingsForm-space8-XD7KG`,
	"spaceTop1": `IOSLayoutSettingsForm-spaceTop1-EEd41`,
	"spaceTop2": `IOSLayoutSettingsForm-spaceTop2-GpyA0`,
	"spaceTop3": `IOSLayoutSettingsForm-spaceTop3-JMGKI`,
	"spaceTop4": `IOSLayoutSettingsForm-spaceTop4-RQG2A`,
	"spaceTop5": `IOSLayoutSettingsForm-spaceTop5-Ur2EU`,
	"spaceTop6": `IOSLayoutSettingsForm-spaceTop6-PjHvH`,
	"spaceTop7": `IOSLayoutSettingsForm-spaceTop7-d7LnP`,
	"spaceTop8": `IOSLayoutSettingsForm-spaceTop8-ppnEW`,
	"noMargin": `IOSLayoutSettingsForm-noMargin-e3Xnh`,
	"padding1": `IOSLayoutSettingsForm-padding1-Rb8pa`,
	"padding2": `IOSLayoutSettingsForm-padding2-Wku5W`,
	"padding3": `IOSLayoutSettingsForm-padding3-n8Tp9`,
	"padding4": `IOSLayoutSettingsForm-padding4-My5Eq`,
	"padding5": `IOSLayoutSettingsForm-padding5-YMk5e`,
	"padding6": `IOSLayoutSettingsForm-padding6-P5fs5`,
	"padding7": `IOSLayoutSettingsForm-padding7-vm9b4`,
	"paddingTop1": `IOSLayoutSettingsForm-paddingTop1-Ju9Kz`,
	"paddingTop2": `IOSLayoutSettingsForm-paddingTop2-OqmDD`,
	"paddingTop3": `IOSLayoutSettingsForm-paddingTop3-F0tJs`,
	"paddingTop4": `IOSLayoutSettingsForm-paddingTop4-lZGdi`,
	"paddingTop5": `IOSLayoutSettingsForm-paddingTop5-ztyFU`,
	"paddingTop6": `IOSLayoutSettingsForm-paddingTop6-YmXsB`,
	"paddingTop7": `IOSLayoutSettingsForm-paddingTop7-L0ugk`,
	"noPadding": `IOSLayoutSettingsForm-noPadding-lImIQ`,
	"spaceMarginBottom0": `IOSLayoutSettingsForm-spaceMarginBottom0-RkZd_`,
	"textBold": `IOSLayoutSettingsForm-textBold-BDsbp`,
	"textBolder": `IOSLayoutSettingsForm-textBolder-u5Od8`,
	"textNormal": `IOSLayoutSettingsForm-textNormal-FttFd`,
	"textDarkBlue": `IOSLayoutSettingsForm-textDarkBlue-BV8WI`,
	"textLightBlue": `IOSLayoutSettingsForm-textLightBlue-cm6Yr`,
	"textLightSandleGreen": `IOSLayoutSettingsForm-textLightSandleGreen-ivKU8`,
	"textLightBrown": `IOSLayoutSettingsForm-textLightBrown-B3P6p`,
	"textMediumMaroon": `IOSLayoutSettingsForm-textMediumMaroon-ZtmR3`,
	"textBrown": `IOSLayoutSettingsForm-textBrown-VXs6a`,
	"textMaroon": `IOSLayoutSettingsForm-textMaroon-jh1r5`,
	"textDarkBrown": `IOSLayoutSettingsForm-textDarkBrown-eq8qb`,
	"textMediumBrown": `IOSLayoutSettingsForm-textMediumBrown-yfeJP`,
	"textSkyBlue": `IOSLayoutSettingsForm-textSkyBlue-_nIPr`,
	"textGray": `IOSLayoutSettingsForm-textGray-VGOHT`,
	"errorMessage": `IOSLayoutSettingsForm-errorMessage-yNyKr`,
	"userText": `IOSLayoutSettingsForm-userText-g4wDg`,
	"panelHeader": `IOSLayoutSettingsForm-panelHeader-sjxgb`,
	"exportSection": `IOSLayoutSettingsForm-exportSection-KQWTL`,
	"exportSectionGridSub": `IOSLayoutSettingsForm-exportSectionGridSub-bBtif`,
	"exportText": `IOSLayoutSettingsForm-exportText-YFMty`,
	"exportLinkImg": `IOSLayoutSettingsForm-exportLinkImg-BM_mV`,
	"exportImg": `IOSLayoutSettingsForm-exportImg-E0YKr`,
	"linkBtn": `IOSLayoutSettingsForm-linkBtn-HzET8`,
	"table": `IOSLayoutSettingsForm-table-Nxyp3`,
	"tableRow": `IOSLayoutSettingsForm-tableRow-JSkuX`,
	"tableCell": `IOSLayoutSettingsForm-tableCell-ivqtn`,
	"formGroup": `IOSLayoutSettingsForm-formGroup-_69hd`,
	"marginTop0": `IOSLayoutSettingsForm-marginTop0-GOnqJ`,
	"marginBottom20": `IOSLayoutSettingsForm-marginBottom20-b6fYt`,
	"bannerImageBg": `IOSLayoutSettingsForm-bannerImageBg-YW5Ra`,
	"bannerDelete": `IOSLayoutSettingsForm-bannerDelete-JrtLp`,
	"exportLink": `IOSLayoutSettingsForm-exportLink-gITfw`,
	"seachContent": `IOSLayoutSettingsForm-seachContent-ziwct`,
	"marginBottom9": `IOSLayoutSettingsForm-marginBottom9-SCjAt`,
	"spaceTop52": `IOSLayoutSettingsForm-spaceTop52-MJNk7`,
	"profileViewInner": `IOSLayoutSettingsForm-profileViewInner-vu6jo`,
	"profileViewMain": `IOSLayoutSettingsForm-profileViewMain-tZmm8`,
	"profileViewlabel": `IOSLayoutSettingsForm-profileViewlabel-bYDVm`,
	"profileViewMainContent": `IOSLayoutSettingsForm-profileViewMainContent-buCWK`,
	"reviewsFormStar": `IOSLayoutSettingsForm-reviewsFormStar-Kz0lE`,
	"addLanguageText": `IOSLayoutSettingsForm-addLanguageText-cy50T`,
	"themeRowContainer": `IOSLayoutSettingsForm-themeRowContainer-qnorq`,
	"adminHorizontalDevided": `IOSLayoutSettingsForm-adminHorizontalDevided-O44jN`,
	"previewContainer": `IOSLayoutSettingsForm-previewContainer-TZuGQ`,
	"iosPreviewLink": `IOSLayoutSettingsForm-iosPreviewLink-exk5n`
};
module.exports = ___CSS_LOADER_EXPORT___;
